import React from "react";
import { graphql } from "gatsby";
import SEO from "../components/SEO";
import { Header } from "../components/Acf/Header";
import { PostList } from "../components/Blog/PostList";
import { decodeEntities } from "../utils/helpers";
import { ContactBlock } from "../components/Acf/ContactBlock";

const Blog = (props) => {
  const { data, pageContext, location } = props;
  const {
    wordpressPost: page = [],
    allWordpressPost,
    categoryFilter,
    wordpressCategory,
    wordpressWpSettings,
    siteSettings,
  } = data;
  const {
    title,
    yoast,
    childWordPressAcfHeader = null,
    childWordPressAcfContactBlock = null,
  } = page ? page : { title: null, yoast: {}, acf: {} };
  const { showAuthor, customCss } = siteSettings.options;
  const { wordpressUrl } = wordpressWpSettings;
  const { title: siteTitle, date_format } = wordpressWpSettings;
  const { edges: posts } = allWordpressPost;

  return (
    <>
      <SEO
        title={`${
          yoast.metaTitle
            ? yoast.metaTitle
            : `Blog | ${decodeEntities(siteTitle)}`
        }`}
        desc={yoast.metaDescription}
        yoast={yoast}
        location={location}
      />
      <Header {...childWordPressAcfHeader} />
      <PostList
        posts={posts}
        title="Latest posts"
        pageContext={pageContext}
        categoryFilter={categoryFilter}
        siteMetadata={wordpressWpSettings}
        pathPrefix={"/news/"}
        showAuthor={showAuthor}
        dateFormat={date_format}
      />
      <ContactBlock {...childWordPressAcfContactBlock} />
    </>
  );
};

export default Blog;

export const pageQuery = graphql`
  query IndexQuery($limit: Int!, $skip: Int!) {
    wordpressWpSettings {
      title
      wordpressUrl
      blogSlug
      siteUrl
      date_format
    }
    siteSettings: wordpressAcfOptions {
      options {
        showAuthor
        customCss
      }
    }
    wordpressPost: wordpressPage(slug: { eq: "news" }) {
      title
      wordpress_id
      yoast {
        metaTitle: title
        metaDescription: metadesc
        meta_robots_noindex
        meta_robots_nofollow
      }
      childWordPressAcfHeader {
        title
        content
        carousel {
          image {
            localFile {
              childImageSharp {
                fluid(maxWidth: 1150, quality: 100) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
        homepage
        theme
      }
      childWordPressAcfContactBlock {
        image {
          localFile {
            childImageSharp {
              fluid(maxWidth: 1200, quality: 95) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        imagePosition
        content
        squareAccent
      }
    }
    categoryFilter: allWordpressPost {
      nodes {
        categories {
          wordpress_id
          id
          name
          slug
          path
          id
        }
      }
    }
    allWordpressPost(
      sort: { fields: date, order: DESC }
      limit: $limit
      skip: $skip
      filter: { slug: { ne: "gatsby-demo" } }
    ) {
      edges {
        node {
          ...PostListFields
        }
      }
    }
    wordpressCategory(slug: { eq: "uncategorised" }) {
      featured_media {
        localFile {
          childImageSharp {
            fluid(maxWidth: 670, quality: 100) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    }
  }
`;
